import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { NgRedux } from '@angular-redux/store';

@Injectable()
export class ApplicationProxyService {
  handshakeBaseUrl = '/ola/api/handshake/';
  formBaseUrl = '/ola/api/form/';
  customerBaseUrl = '/ola/api/customer/';
  accountBaseUrl = '/ola/api/account/';
  userBaseUrl = '/ola/api/user/';
  plaidBaseUrl = '/ola/api/plaid/';
  fundingBaseUrl = '/ola/api/moneymovement/';
  cipBaseUrl = '/ola/api/soap/';
  tkaBaseUrl = '/ola/api/tka/';

  constructor(rest: RestService, http: HttpClient, redux: NgRedux) {
    this.rest = rest;
    this.http = http;
    this.redux = redux;
  }

  // Hardcoding the URL is going to byte us in the ass
  // @TODO create a env var to change ;)
  getSiteTags(cb) {
    this.rest
      .get('/ola/assets/sitetag/site-tag-store.json')
      .then((res) => cb(res));
  }

  getWords() {
    return this.http.get('/ola/api/words/getWords').toPromise();
  }

  getAgreements(agreementName, cb) {
    this.rest
      .get(`/ola/assets/agreements/${agreementName}.json`)
      .then((res) => cb(res));
  }

  hello() {
    return new Promise((resolve) => {
      this.rest.get(`${this.handshakeBaseUrl}hello`).then((res) => {
        resolve(res);
      });
    });
  }

  // /api/controllers/HandshakeController
  handshake(value, cb) {
    this.rest
      .post(`${this.handshakeBaseUrl}handshake`, value)
      .then((res) => cb(res));
  }

  ping(value, cb) {
    this.rest
      .post(`${this.handshakeBaseUrl}ping`, value)
      .then((res) => cb(res));
  }

  clearSession() {
    return new Promise((resolve) => {
      this.rest
        .get(`${this.handshakeBaseUrl}clearSession`)
        .then((res) => resolve(res));
    });
  }

  // /api/controllers/FormController
  hasExperiments(value) {
    return new Promise((resolve) => {
      this.rest.post(`${this.formBaseUrl}hasExperiments`, value).then((res) => {
        resolve(res);
      });
    });
  }

  getFormJSON(appType, step, obj, cb) {
    this.rest
      .post(`${this.formBaseUrl}schema?app=${appType}&page=${step}`, obj)
      .then((res) => cb(res));
  }

  getValidationSchema(cb) {
    this.rest.get(`${this.formBaseUrl}validationSchema`).then((res) => cb(res));
  }

  getOccupationList(cb) {
    this.rest.get(`${this.formBaseUrl}occupationList`).then((res) => cb(res));
  }

  getIncomeList(cb) {
    this.rest.get(`${this.formBaseUrl}incomeList`).then((res) => cb(res));
  }
  // /api/controllers/CustomerController
  identityCreateUser(value, cb) {
    this.rest
      .post(`${this.customerBaseUrl}idmCreateUser`, value)
      .then((res) => cb(res));
  }

  submitSOAPRequest(value, cb) {
    this.rest
      .post(`${this.customerBaseUrl}submitSOAPRequest`, value)
      .then((res) => cb(res));
  }

  associateGoals(value, cb) {
    this.rest
      .post(`${this.customerBaseUrl}createUserGoals`, value)
      .then((res) => cb(res));
  }

  getCustByGuid(cb) {
    this.rest.get(`${this.customerBaseUrl}get`).then((res) => cb(res));
  }

  custFuzzySearch(value, cb) {
    this.rest
      .post(`${this.customerBaseUrl}search`, value)
      .then((res) => cb(res));
  }

  getLinkToken() {
    return this.http.get(`${this.plaidBaseUrl}getLinkToken`).toPromise();
  }

  logContactInfo(value, cb) {
    this.rest
      .post(`${this.customerBaseUrl}logContactInfo`, value)
      .then((res) => cb(res));
  }

  // /api/controllers/AccountController
  getDepositAccounts(cb) {
    this.rest
      .get(`${this.accountBaseUrl}depositAccounts`)
      .then((res) => cb(res));
  }

  getOneAllyAccounts(value, cb) {
    this.rest
      .post(`${this.accountBaseUrl}getOneAllyAccounts`, value)
      .then((res) => cb(res));
  }

  setDepositAccount(value, cb) {
    this.rest
      .post(`${this.accountBaseUrl}setDepositAccount`, value)
      .then((res) => cb(res));
  }

  getApplication(id, cb) {
    this.rest.get(`${this.accountBaseUrl}get?id=${id}`).then((res) => cb(res));
  }

  submitApplication(value) {
    return this.http
      .post(`${this.accountBaseUrl}submit`, value)
      .toPromise()
      .catch(
        (e) =>
          new Promise((resolve) => {
            resolve({ statusCode: 408, result: 'Timed out' });
          })
      );
  }

  depositFunds(value, cb) {
    this.rest
      .post(`${this.accountBaseUrl}depositFunds`, value)
      .then((res) => cb(res));
  }

  getDocumentStatus(documentRequestId, cb) {
    this.rest
      .get(`${this.accountBaseUrl}getDocumentStatus?documentRequestId=${documentRequestId}`)
      .then((res) => cb(res));
  }

  getLookup(values, cb) {
    this.rest
      .get(
        `${this.accountBaseUrl}getLookup?code=${values.code}&accountNumber=${values.accountNumber}`
      )
      .then((res) => cb(res));
  }

  sendEmail(values, cb) {
    this.rest
      .post(
        `${this.accountBaseUrl}sendEmail?documentRequestId=${values.documentRequestId}&type=${values.type}`,
        values.payload
      )
      .then((res) => cb(res));
  }

  sendSuccessEmail(values, cb) {
    this.rest
      .post(
        `${this.accountBaseUrl}sendSuccessEmail?documentRequestId=${values.documentRequestId}&type=${values.type}`,
        values.payload
      )
      .then((res) => cb(res));
  }

  postDocuments(values, cb) {
    const promises = values.files.map((file) => {
      const headers = new Headers();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      const metaData = JSON.stringify({
        multipartFile: null,
        applicantType: file.id.split('-')[1],
        documentType: file.id.split('-')[0],
      });
      const formData = new FormData();
      formData.append('meta', metaData); // any text data HAS to be first, sails will blow it away otherwise
      formData.append('file', file.file);

      return this.http
        .post(`${this.accountBaseUrl}postDocuments?documentRequestId=${values.documentRequestId}`, formData, {
          withCredentials: true,
        })
        .toPromise();
    });
    Promise.all(promises)
      .then((results) => {
        // Look for any errors in the results
        const result = results.reduce((value, result) => {
          // If it's an error return it, else return the current value (will be the first result
          // if no errors have been found)
          return result.error ? result : value;
        }, results[0]);
        cb(result);
      })
      .catch((e) => {
        cb({ error: 'error' });
      });
  }

  checkSubmissionStatus() {
    return this.http
      .get(`${this.accountBaseUrl}checkSubmissionStatus`)
      .toPromise();
  }

  getSubmissionResponse() {
    return this.http
      .get(`${this.accountBaseUrl}getSubmissionResponse`)
      .toPromise();
  }

  // /api/controllers/UserController
  login(value, cb) {
    this.rest.post(`${this.userBaseUrl}login`, value).then((res) => cb(res));
  }

  getAccountsLink(cb) {
    // Unauthed version
    this.rest.get(`${this.userBaseUrl}accountsLink`).then((res) => cb(res));
  }

  forgetPassword(value, cb) {
    this.rest
      .post(`${this.userBaseUrl}forgetPassword`, value)
      .then((res) => cb(res));
  }

  getDashboardUrl(value) {
    return new Promise((resolve) => {
      this.rest
        .post(`${this.userBaseUrl}dashboard`, value)
        .then((res) => resolve(res));
    });
  }

  plaidInit(value, cb) {
    this.rest
      .post(`${this.plaidBaseUrl}plaidInit`, value)
      .then((res) => cb(res));
  }

  // /api/controllers/PlaidController
  plaidError(value, cb) {
    this.rest
      .post(`${this.plaidBaseUrl}plaidError`, value)
      .then((res) => cb(res));
  }

  checkAccountNumbers(value, cb) {
    this.rest
      .post(`${this.plaidBaseUrl}checkAccountNumbers`, value)
      .then((res) => cb(res));
  }

  // /api/controllers/MoneymovementController
  initiateOneAllyTransfer(value, cb) {
    this.rest
      .post(`${this.fundingBaseUrl}initiateOneAllyTransfer`, value)
      .then((res) => cb(res));
  }

  createACHProfile(value, cb) {
    this.rest
      .post(`${this.fundingBaseUrl}createACHProfile`, value)
      .then((res) => cb(res));
  }

  validateDTCNumber(value, cb) {
    this.rest
      .post(`${this.fundingBaseUrl}validateDTCNumber`, value)
      .then((res) => cb(res));
  }

  submitAcats(value, cb) {
    this.rest
      .post(`${this.fundingBaseUrl}submitAcats`, value)
      .then((res) => cb(res));
  }

  // /api/controllers/SoapController
  getKBA(value, cb) {
    this.rest.post(`${this.cipBaseUrl}getKBA`, value).then((res) => cb(res));
  }

  verifyKBA(value, cb) {
    this.rest.post(`${this.cipBaseUrl}verifyKBA`, value).then((res) => cb(res));
  }

  createGoalSession() {
    return this.http.post(`${this.tkaBaseUrl}createGoalSession`).toPromise();
  }

  updateGoalSession(value) {
    return this.http
      .post(`${this.tkaBaseUrl}updateGoalSession`, value)
      .toPromise();
  }

  getHistoricValues(value) {
    return this.http.post(
      `${this.tkaBaseUrl}getPortfoliosWithHistoricValues`,
      value
    );
  }

  getBankRateByRateType(value) {
    return this.http.post(`${this.tkaBaseUrl}getBankRateByRateType`, value);
  }

  getPortfolioTierAssetsAndHoldings(value) {
    return this.http.post(
      `${this.tkaBaseUrl}getPortfolioTierAssetsAndHoldings`,
      value
    );
  }

  getModelSelection(value) {
    return this.http.post(`${this.tkaBaseUrl}getModelSelection`, value);
  }

  initializeSession(accessToken, relayState, userNamePvtEncrypt) {
    return this.http
      .post(`${this.userBaseUrl}initSession`, {
        relayState,
        userNamePvtEncrypt,
        accessToken,
      })
      .toPromise();
  }
}
